import LegalPage from '../components/LegalPage'
import terms from '../../../legal/terms-of-use.md?raw'

export default function TermsOfUse() {
  return <LegalPage markdown={terms} title="Terms of Use" />
}
